export const companyFormDefaultText = {
  // Headings
  heading: "Become a recruitment partner",
  leadText:
    "You can register your company as a service provider on the workinfinland.fi website.",
  thankYouHeading: "Thank you! We have received your submission.",
  thankYouLeadText:
    "Our team will review your submission and get back to you shortly.",
  companyIdHeading: "Company identity number",
  companyCriteriaApprovedHeading: "Company criteria approved",
  companyContactHeading: "Company contact information",
  companyServicesHeading: "Description of services",
  companyServicesLeadText:
    "Please provide a service description and website in at least one language (Finnish, Swedish, or English) that you offer your services in.",
  companyLogoHeading: "Upload Company Logo",

  // Errors
  unmetCriteriaErrorMessage:
    "Unfortunately, it seems your company does not meet all the criteria.",
  fieldRequiredErrorMessage: "This field is required",
  fieldInvalidFormatErrorMessage: "Invalid format",
  unsupportedFileTypeErrorMessage: "Unsupported file type",
  submitFailedErrorMessage:
    "We could not send your registration. Please try again later.",

  // Fields
  companyIdLabel: "Company ID",
  companyIdPlaceholder: "Company ID",
  companyNameLabel: "Company name",
  companyNamePlaceholder: "Company name",
  companyPhoneLabel: "Phone number (internal use only)",
  companyPhonePlaceholder: "00 000 0000",
  companyEmailLabel: "Email address (internal use only)",
  companyEmailPlaceholder: "email@address.com",
  companyLogoLeadText: "Please add jpg or webp format max 1 MB.",
  companyLogoUploadAreaCaption: "Drag your image or click to upload",
  typeOfServiceLabel: "Service type (You can select more than one)",
  typeOfServicePlaceholder: "Service type",
  companyDescriptionLabel: "Description",
  companyDescriptionPlaceholder: "Write a service description",
  companyWebsiteLabel: "Website of service",
  companyWebsitePlaceholder: "https://",
  termsField: "I agree to the terms and conditions.",
};

export const companyIdRegex = /^\d{7}-\d{1}$/;
export const companyWebsiteRegex = /^http[s]?:\/\/.+\..+/;
export const companyPhoneRegex = /^\+\d+$/;
export const companyEmailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
